var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rounded transition duration-150" }, [
    _c("div", { staticClass: "py-5 border-b border-gray-200" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm.subtitle
        ? _c(
            "p",
            { staticClass: "mt-1 max-w-2xl text-sm leading-5 text-gray-500" },
            [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
          )
        : _vm._e(),
    ]),
    _c(
      "dl",
      {
        staticClass: "grid grid-cols-1 col-gap-4 row-gap-8 sm:grid-cols-2 py-5",
      },
      [_vm._t("content")],
      2
    ),
    _c("div", { staticClass: "-mt-px flex" }, [
      _c(
        "button",
        {
          class: _vm.buttonClasses,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("update")
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "w-4 h-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "19",
                viewBox: "0 0 18 19",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M12.75 2.75023C12.947 2.55324 13.1808 2.39699 13.4382 2.29038C13.6956 2.18378 13.9714 2.12891 14.25 2.12891C14.5286 2.12891 14.8044 2.18378 15.0618 2.29038C15.3192 2.39699 15.553 2.55324 15.75 2.75023C15.947 2.94721 16.1032 3.18106 16.2098 3.43843C16.3165 3.6958 16.3713 3.97165 16.3713 4.25023C16.3713 4.5288 16.3165 4.80465 16.2098 5.06202C16.1032 5.31939 15.947 5.55324 15.75 5.75023L5.625 15.8752L1.5 17.0002L2.625 12.8752L12.75 2.75023Z",
                  stroke: "#010A11",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
          _c("span", { staticClass: "ml-3" }, [_vm._v(" Edit ")]),
        ]
      ),
      _c(
        "button",
        {
          class: _vm.buttonClasses,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("remove")
            },
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "w-4 h-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "16",
                viewBox: "0 0 14 16",
                fill: "none",
              },
            },
            [
              _c("g", { attrs: { "clip-path": "url(#clip0_282_84)" } }, [
                _c("path", {
                  attrs: {
                    d: "M4.225 0.553125C4.39375 0.2125 4.74062 0 5.11875 0H8.88125C9.25938 0 9.60625 0.2125 9.775 0.553125L10 1H13C13.5531 1 14 1.44687 14 2C14 2.55312 13.5531 3 13 3H1C0.446875 3 0 2.55312 0 2C0 1.44687 0.446875 1 1 1H4L4.225 0.553125ZM1 4H13V14C13 15.1031 12.1031 16 11 16H3C1.89688 16 1 15.1031 1 14V4ZM4 6C3.725 6 3.5 6.225 3.5 6.5V13.5C3.5 13.775 3.725 14 4 14C4.275 14 4.5 13.775 4.5 13.5V6.5C4.5 6.225 4.275 6 4 6ZM7 6C6.725 6 6.5 6.225 6.5 6.5V13.5C6.5 13.775 6.725 14 7 14C7.275 14 7.5 13.775 7.5 13.5V6.5C7.5 6.225 7.275 6 7 6ZM10 6C9.725 6 9.5 6.225 9.5 6.5V13.5C9.5 13.775 9.725 14 10 14C10.275 14 10.5 13.775 10.5 13.5V6.5C10.5 6.225 10.275 6 10 6Z",
                    fill: "#010A11",
                  },
                }),
              ]),
              _c("defs", [
                _c("clipPath", { attrs: { id: "clip0_282_84" } }, [
                  _c("rect", {
                    attrs: { width: "14", height: "16", fill: "white" },
                  }),
                ]),
              ]),
            ]
          ),
          _c("span", { staticClass: "ml-3" }, [_vm._v(" Remove ")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }